import {AfterViewInit, Component, ElementRef, EventEmitter, OnDestroy, Output, ViewChild} from '@angular/core';
import {CalendarService} from '../calendar.service';
import {CalRepeat} from "../utils/model/CalEvent";
import {CalendarUtils} from "../CalendarUtils";
@Component({
  selector: 'calendar-repeat-modal',
  templateUrl: './dialog-repeat.component.html',
  styleUrls: ['./dialog-repeat.component.scss']
})
export class CalendarDialogRepeatComponent implements AfterViewInit, OnDestroy {
  @Output() onRepeat = new EventEmitter<CalRepeat>();
  // @ViewChild('repeatModal') repeatModal: ElementRef;
  @ViewChild('repeatStart') repeatStart!: ElementRef;
  @ViewChild('repeatUntil') repeatUntil!: ElementRef;
  start: any;
  until: any;
  rrmode: any;
  repeatTypes: any[];
  weekDays: any[];
  data: any = {};
  $modal: any;
  dateFormat: string = 'DD/MM/YYYY';

  constructor(
    private calendarService: CalendarService,
  ) {
    this.repeatTypes = CalendarUtils.repeatTypes;
    this.weekDays = CalendarUtils.weekDays;
  }

  ngAfterViewInit() {
    // this.$modal = $(this.repeatModal.nativeElement);
    // document.body.appendChild(this.repeatModal.nativeElement);
  }

  ngOnDestroy() {
    // if (this.$modal.is(':visible')) {
    //   this.$modal.modal('hide').on('hidden.bs.modal', function () {
    //     $(this).remove();
    //   });
    // } else {
    //   this.$modal.remove();
    // }
  }

  openRepeat(data: any) {
    this.data = data || {};
    this.initData();
    // this.$modal.modal('show');
  }

  saveRepeat() {
    this.onRepeat.emit(this.getRepeatData());
  }

  changeWeekDay(item: any) {
    item.checked = !item.checked;
    if (this.getWeekDayChecked().length < 1) {
      item.checked = true;
    }
    this.saveRepeat();
  }

  changeRepeatTypes($event: any) {
    if (!this.data.wkdays) {
      this.weekDays.forEach(item => {
        item.checked = false;
      });

    } else {
      this.weekDays.forEach(item => {
        if (this.data.wkdays.indexOf(item.value) > -1) {
          item.checked = true;
        } else {
          item.checked = false;
        }
      });
    }
    this.saveRepeat();
  }


  changeDateStart(event: any) {
    this.start = event;
    if (!this.start || !this.start.getTime()) {
      this.start = new Date();
    }
    this.saveRepeat();
  }

  changeDateUntil(event: any) {
    this.until = event
    if (!this.until || !this.until.getTime() || this.start >= this.until) {
      this.until = new Date(this.start.getFullYear(), this.start.getMonth(), this.start.getDate());
      this.until.setMonth(this.until.getMonth() + 1);
    }
    this.saveRepeat();
  }

  getRepeatData(): CalRepeat {
    const params: any = {
      rrmode: this.rrmode,
      lstart: this.start.getTime(),
      until: this.until.getTime(),
      wkdays: []
    };

    if (params.rrmode == 'WEEKLY') {

      // this.weekDays.forEach(item => {
      //   if (item.checked) {
      //     params.wkdays += item.value + ',';
      //   }
      // });
      // params.wkdays = params.wkdays.slice(0, -1);
      params.wkdays = this.getWeekDayChecked().map(item => item.value);
    }

    return params;
  }

  getWeekDayChecked() {
    return this.weekDays.filter(item => {
      return item.checked;
    });
  }

  private initData() {
    this.rrmode = this.data.rrmode || 'DAILY';
    this.start = new Date(this.data.lstart || new Date());
    this.until = new Date(this.data.until || new Date());
    // this.changeDate();
    if (this.data.wkdays) {
      this.weekDays.forEach(item => {
        if (this.data.wkdays.indexOf(item.value) > -1) {
          item.checked = true;
        } else {
          item.checked = false;
        }
      });
    } else {
      this.weekDays[(this.start.getDay() + 6) % 7].checked = true;
    }
  }
}
